import styled from 'styled-components';
import scroll_down from '../../Assets/Images/scroll_down.png';

const ScrollDownIcon = styled.div`
  width: 10vh;
  height: 10vh;
  background-image: url(${scroll_down});
  background-size: cover;
  position: absolute;
  left: 45vw;
  bottom: 10vh;
`;

export default ScrollDownIcon;
